/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import "../../pages/Home/home.scss";
import { UploadOutlined } from "@ant-design/icons";
import { Upload, Image } from "antd";
import { Divider } from "../../../node_modules/antd/es/index";
import ImgCrop from "antd-img-crop";
import { ValidateFileUploads } from "./ValidateFlightUser";

export default function OtherPassportsFileModal({
  show,
  handleClose,
  passportCount,
  getOtherPassports,
}) {
  const [errors, setErrors] = useState([]);

  const [uploadsArray, setUploadsArray] = useState([
    {
      passport_front_page: null,
      avatar_photo: null,
      green_card: null,
      photo_preview: null,
      passport_preview: null,
      green_photo_preview: null,
    },
  ]);

  useEffect(() => {
    if (passportCount) {
      let muploadsArray = [];
      [...Array(passportCount)].map((d, index) => {
        muploadsArray = [
          ...muploadsArray,
          {
            passport_front_page:
              uploadsArray.length > 0
                ? uploadsArray[index]
                  ? uploadsArray[index]?.passport_front_page
                  : null
                : null,
            avatar_photo:
              uploadsArray.length > 0
                ? uploadsArray[index]
                  ? uploadsArray[index]?.avatar_photo
                  : null
                : null,
            green_card:
              uploadsArray.length > 0
                ? uploadsArray[index]
                  ? uploadsArray[index]?.green_card
                  : null
                : null,
            photo_preview:
              uploadsArray.length > 0
                ? uploadsArray[index]
                  ? uploadsArray[index]?.photo_preview
                  : null
                : null,
            passport_preview:
              uploadsArray.length > 0
                ? uploadsArray[index]
                  ? uploadsArray[index]?.passport_preview
                  : null
                : null,
            green_photo_preview:
              uploadsArray.length > 0
                ? uploadsArray[index]
                  ? uploadsArray[index]?.green_photo_preview
                  : null
                : null,
          },
        ];
        setUploadsArray(muploadsArray);
        return null;
      });
    }
  }, [passportCount]);

  // useEffect(() => {
  //   getOtherPassports(errors);
  // }, [errors]);

  const handleFileChange = (file, name, previewName, index) => {
    const filesArray = [...uploadsArray];
    filesArray[index][name] = file;
    filesArray[index][previewName] = URL.createObjectURL(file);
    if (errors && errors.length > 0) errors[index][name] = null;

    setUploadsArray(filesArray);
    setErrors(errors);
  };

  const handleUpload = () => {
    const errorsq = ValidateFileUploads(uploadsArray);
    let errorValues = [];
    errorsq.map((d) => {
      errorValues = [
        ...errorValues,
        d.passport_front_page,
        d.avatar_photo,
        d.green_card,
      ];
      return null;
    });
    console.log("Errors", errorValues);

    if (errorValues.every((d) => d === null)) {
      // setState({ ...state, errors: errors.errors, submitting: false });
      getOtherPassports(uploadsArray);
      // dispatch({
      //   type:flightActionTypes.SET_OTHERS_PASSPORTS,
      //   payload:uploadsArray
      // })
      handleClose();
    } else {
      setErrors(errorsq);
    }
  };

  const handleRemove = (name, previewName, index) => {
    const filesArray = [...uploadsArray];
    filesArray[index][name] = null;
    filesArray[index][previewName] = null;
    if (errors && errors.length > 0) errors[index][name] = null;

    setUploadsArray(filesArray);
    // setUploadsArray(uploadsArray.splice(i, 1));
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };
  console.log("Uploads", uploadsArray);
  return (
    <Modal
      open={show}
      onCancel={handleClose}
      centered
      closable={true}
      maskClosable={false}
      footer={false}
      title="Upload Passport For Other Nationality"
      className="modal-image-upload"
      width="50%"
    >
      {/* <div className="upload-controls-container mt-3"> */}
      <div className="upload-controls-container">
        {/* <RSC style={{ width: 770, height: "100vh" }}> */}
        {uploadsArray.map((d, index) => {
          return (
            <div>
              <Divider orientation="left">Applicant {index + 1}</Divider>
              <div
                style={{
                  display: "flex",
                  justifyContent: "",
                  flexWrap: "wrap",
                }}
              >
                <div className="image-container">
                  <label className="font-weight-bold"> Passport</label>
                  {/* <Divider orientation="left">Passport</Divider> */}

                  <ImgCrop showGrid rotationSlider aspectSlider showReset>
                    <Upload
                      beforeUpload={(file) => {
                        console.log("file", URL.createObjectURL(file));
                        handleFileChange(
                          file,
                          "passport_front_page",
                          "passport_preview",
                          index
                        );
                        return false;
                      }}
                      onRemove={(e) =>
                        handleRemove(
                          "passport_front_page",
                          "passport_preview",
                          index
                        )
                      }
                      listType="picture-card"
                      showUploadList={{
                        showPreviewIcon: true,
                        showRemoveIcon: true,
                      }}
                      onPreview={onPreview}
                      className="mt-3"
                      maxCount={1}
                    >
                      {uploadsArray[index].passport_preview === null && (
                        <div
                          className="image-list"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div className="text-image-container">
                            <UploadOutlined style={{ fontSize: 40 }} />{" "}
                          </div>
                        </div>
                      )}
                    </Upload>
                  </ImgCrop>
                  {errors && errors[index] && (
                    <span className="text-danger font-size-12">
                      {errors[index].passport_front_page}
                    </span>
                  )}
                </div>

                <div className="image-container">
                  <label className="font-weight-bold">Photo</label>
                  {/* <Divider orientation="left">Photo</Divider> */}

                  <ImgCrop showGrid rotationSlider aspectSlider showReset>
                    <Upload
                      beforeUpload={(file) => {
                        console.log("file", URL.createObjectURL(file));
                        handleFileChange(
                          file,
                          "avatar_photo",
                          "photo_preview",
                          index
                        );
                        return false;
                      }}
                      onRemove={(e) =>
                        handleRemove("avatar_photo", "photo_preview", index)
                      }
                      listType="picture-card"
                      showUploadList={{
                        showPreviewIcon: true,
                        showRemoveIcon: true,
                      }}
                      onPreview={onPreview}
                      className="mt-3"
                      maxCount={1}
                    >
                      {uploadsArray[index].photo_preview === null && (
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div className="text-image-container">
                            <UploadOutlined style={{ fontSize: 40 }} />{" "}
                            {/* <span className="text-image">Photo</span> */}
                          </div>
                        </div>
                      )}
                      {/* <Button icon={<UploadOutlined />}>Photo</Button> */}
                    </Upload>
                  </ImgCrop>
                  {errors && errors[index] && (
                    <span className="text-danger font-size-12">
                      {errors[index].avatar_photo}
                    </span>
                  )}
                </div>

                <div className="image-container">
                  <label className="font-weight-bold">
                    Green Card / Status
                  </label>
                  {/* <Divider orientation="left">Photo</Divider> */}

                  <ImgCrop showGrid rotationSlider aspectSlider showReset>
                    <Upload
                      beforeUpload={(file) => {
                        console.log("file", URL.createObjectURL(file));
                        handleFileChange(
                          file,
                          "green_card",
                          "green_photo_preview",
                          index
                        );
                        return false;
                      }}
                      // onRemove={(e) => handleRemove(e, index)}
                      onRemove={(e) =>
                        handleRemove("green_card", "green_photo_preview", index)
                      }
                      listType="picture-card"
                      showUploadList={{
                        showPreviewIcon: true,
                        showRemoveIcon: true,
                      }}
                      onPreview={onPreview}
                      className="mt-3"
                      maxCount={1}
                    >
                      {uploadsArray[index].green_photo_preview === null && (
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div className="text-image-container">
                            <UploadOutlined style={{ fontSize: 40 }} />{" "}
                            {/* <span className="text-image">Green Card</span> */}
                          </div>
                        </div>
                      )}
                    </Upload>
                  </ImgCrop>
                  {errors && errors[index] && (
                    <span className="text-danger font-size-12">
                      {errors[index].green_card}
                    </span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
        <Divider />
      </div>

      {/* </div> */}
      <div className="footer-modal">
        <button className="btn btn-dark blue" onClick={handleUpload}>
          Upload Documents
        </button>
      </div>
    </Modal>
  );
}
